
import common from '../../api/common';
import Toast from 'vux/src/components/toast/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'

export default {
components: {
Toast,
Confirm
},
data() {
return {
telephone: '',//手机号
phoneCode: '',//验证码
count: '获取验证码',
isSubmit: true,
code: this.$route.query.code || '',
isGet: true,

showPositionValue: false, //是否显示提示
position: 'center', //提示信息的位置
toastText: '', // 提示文本

show: false,
subText: '',
confirmText: '',//该手机号尚未注册，前往注册，审核通过后即可开启您的个人线上医馆
phoneNumber: '400-666-0101',
regEn: /[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/im,
regCn: /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im,
}
},

methods: {

onsubmit(){
if(this.subText == '去注册'){
this.$router.push({path: '/login'});
}else{
window.location.href = 'tel://' + this.phoneNumber;
}
},

getWechatCode(){
this.code = common.getQueryString(window.location.search.substr(1), 'code');
console.log(this.code);
},

countDown(){
let _this = this;
let num = 60;
let timer = setInterval(function () {
num--
_this.count = num + 's重新获取';
_this.isGet = false;
if (num === 0) {
_this.isGet = true;
_this.count = '获取验证码';
clearInterval(timer);
}
}, 1000);
},

checkout(){
if(isNaN(this.telephone) || this.regEn.test(this.telephone) || this.regCn.test(this.telephone)){
this.isSubmit = false;
this.toastText = '手机号为数字';
this.showPositionValue = true;
}else if(this.telephone.length>11){
this.telephone = this.telephone.slice(0,11)
}else{
this.isSubmit = true;
}
},

checkoutCode(){
if(isNaN(this.phoneCode) || this.regEn.test(this.phoneCode) || this.regCn.test(this.phoneCode)){
this.isSubmit = false;
this.toastText = '验证码为数字';
this.showPositionValue = true;
}else if(this.phoneCode.length>4){
this.phoneCode = this.phoneCode.slice(0,4)
}else{
this.isSubmit = true;
}
},

getCode(){
if(this.isGet){
let reg = /^1[3456789]\d{9}$/;
this.istrue = reg.test(this.telephone);
if(!this.istrue){
this.toastText = '请输入正确的手机号';
this.showPositionValue = true;
return;
}else{
this.isGet = false;
















let params = {
parameters: this.telephone,
parametersone: 1
}
this.$http.post('api/AppHomePage/getPcode', params).then(function(res){//13810129734
if(res.body.result == 2){
this.isGet = true;
this.confirmText = '该手机号尚未注册，前往注册，审核通过后即可开启您的个人线上医馆';
this.subText = '去注册';
this.show = true;
}else if(res.body.result == 3){
this.isGet = true;
this.subText = '联系客服';
this.confirmText = '您的账号尚未认证，请打开北京好中医APP登录提交认证，如需帮助请联系客服：400-666-0101';
this.show = true;
}else{
this.countDown();
}
},function(res){
this.isGet = false;
this.toastText = res.body.message;
this.showPositionValue = true;
});




}
}
},

submitRegister(){

if(!this.telephone){
this.toastText = '请输入正确的手机号';
this.showPositionValue = true;
return;
}else if(!this.phoneCode){
this.toastText = '请输入正确的验证码';
this.showPositionValue = true;
return;
}{
this.isSubmit = false;
let params = {
telePhone: this.telephone,
phoneCode: this.phoneCode,
code: this.code,
};
this.$doRequest("api/AppHomePage/doctorLogin", params,res => {
this.isSubmit = true;
this.$router.push({path: '/doctorDetails',query: {openid: res.openid,telePhone: this.telephone}});
},err => {
this.isSubmit = true;
this.toastText = err.message;
this.showPositionValue = true;
});
}
},



newSubmit(){
if(!this.telephone){
this.toastText = '请输入正确的手机号';
this.showPositionValue = true;
return;
}else if(!this.phoneCode){
this.toastText = '请输入正确的验证码';
this.showPositionValue = true;
return;
}{
let params = {
telePhone: this.telephone,
phoneCode: this.phoneCode,
code: this.code,
};
this.$http.post('api/AppHomePage/doctorLogin',params).then(function(res){//13810129734
if(res.body.result > 0){
this.isSubmit = true;
let session = {
openid: res.body.openid,
sessionid: res.body.session
};
localStorage.setItem('session',JSON.stringify(session));
this.$router.push({path: '/doctorDetails',query: {openid: res.body.openid,telePhone: this.telephone}});
}else{
this.isSubmit = true;
this.toastText = res.body.message;
this.showPositionValue = true;
}
},function(res){
this.isSubmit = true;
this.toastText = res.body.message;
this.showPositionValue = true;
});
}
},




goPath(){
this.$router.push({path: '/hospitalList', query: {
doctorname: this.doctorname,
telephone: this.telephone,
phoneCode: this.phoneCode,
site: this.site}
});
}
},

created: function() {
if(this.code == ''){
this.getWechatCode();
}
document.title = '医生登录';
}
}



// WEBPACK FOOTER //
// ./src/views/register/index.vue